
import { Vue, Options, prop } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import { AccountController } from "../../controllers/AccountController";
import { BalanceController } from "../../controllers/BalanceController";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Constants";
import { GTMCommonEvent } from "@/app/infrastructures/misc/gtm-event/common-event";
import { FlagsPermissionCodBalance } from "@/feature-flags/flags-permission-cod-balance";
import {
  formatByCountry,
  resolveCountry
} from "@/app/infrastructures/misc/Utils";

class Props {
  collapse = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: {
    OverlayPanel
  }
})
export default class CardSisaSaldoCOD extends Vue.with(Props) {
  get visibleSaldo() {
    return FlagsPermissionCodBalance.permission_cod_balance_enable.isEnabled();
  }
  // methods
  openTooltip(event: Event) {
    (this.$refs as any)?.opSisaSaldo?.toggle(event);
  }

  hideTooltip() {
    (this.$refs as any)?.opSisaSaldo?.hide();
  }

  get accountData() {
    return AccountController.accountData;
  }

  get priceView() {
    const value = BalanceController.balanceData.walletBalanceCod;
    const sign = value < 0 ? "- " : "";
    const currency = resolveCountry() === "MY" ? "RM" : "Rp";
    return formatByCountry(Math.abs(value), {
      type: "money",
      prefix: `${sign}${currency}`
    });
  }

  get isLoadingBalance() {
    return BalanceController.isLoadingBalance;
  }

  get balanceData() {
    return BalanceController.balanceData;
  }

  isSenderAccount = IS_SENDER_ACCOUNT;

  isHideBalanceDetail = false;
  gotoBalance() {
    this.$emit("click");
    this.$router.push("/cod-income");
    if (IS_SENDER_ACCOUNT) GTMCommonEvent("cod_income");
  }
}
